import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Observable, ReplaySubject } from "rxjs";

import { Categoria } from "../Entities/Categoria/categoria.entity";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class CategoriasRepository {
  private categorias: ReplaySubject<Categoria[]>;

  constructor(private http: HttpClient) {}

  //GET
  obtenerCategorias(overwrite = false): Observable<Categoria[]> {
    if (!this.categorias || overwrite) {
      if (!this.categorias) this.categorias = new ReplaySubject(1);

      this.http.get<Categoria[]>(`${enlineaBackendUrl}/api/Categorias?spinner=true`).subscribe((results) => {
        this.categorias.next(results);
      });
    }

    return this.categorias;
  }
  obtenerCategoriaRoles(): Observable<Categoria[]> {
    return this.http.get<Categoria[]>(`${enlineaBackendUrl}/api/Categorias/ObtenerCategoriasConRoles`);
  }
}
